import dayjs from "dayjs";
import { Box, Typography } from "@mui/material";

import { IUploadHistory } from "./Governance.types";
import { GovernanceUploadSummary } from "./GovernanceUploadSummary";
import { GovernanceUploadButton } from "./GovernanceUploadButton";

type GovernanceActivityProps = {
  organizationId: string;
  /** Undefined antes da primeira carga: a tela é a mesma, com os valores vazios. */
  upload?: IUploadHistory;
};

type FieldProps = {
  label: string;
  value: string;
};

function Field({ label, value }: FieldProps) {
  return (
    <Box>
      <Typography sx={{ color: "text.secondary", fontSize: "12px", marginBottom: "8px" }}>
        {label}
      </Typography>
      <Typography sx={{ color: "text.primary", fontSize: "14px", fontWeight: 700 }}>
        {value}
      </Typography>
    </Box>
  );
}

/** Aba Atividade: o upload mais recente, com os campos empilhados e o botão de carregar. */
export function GovernanceActivity({ organizationId, upload }: GovernanceActivityProps) {
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", gap: "40px", marginBottom: "24px" }}>
        <Field label="Arquivo" value={upload?.fileName ?? "—"} />
        <Field
          label="Carregado em"
          value={upload ? dayjs(upload.createdAt).format("DD/MM/YYYY - HH:mm:ss") : "—"}
        />
      </Box>

      <GovernanceUploadSummary upload={upload} />

      <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: "24px" }}>
        <GovernanceUploadButton organizationId={organizationId} />
      </Box>
    </Box>
  );
}
